export enum Priority {
  HIGH = 'High',
  MEDIUM = 'Medium',
  LOW = 'Low',
}

export enum ViewMode {
  DASHBOARD = 'dashboard',
  IDEAS = 'ideas',
  ARCHIVE = 'archive',
  CHAT = 'chat',
}

export interface Topic {
  id: string;
  name: string;
}

export interface Idea {
  id: string;
  title: string;
  description: string;
  priority: Priority;
  topicId: string;
  isDone: boolean;
  createdAt: string; // ISO string
  completedAt?: string; // ISO string
}

export interface ChatMessage {
  id: string;
  role: 'user' | 'model';
  content: string;
  timestamp: string;
}

export interface AppData {
  topics: Topic[];
  ideas: Idea[];
  chats: ChatMessage[];
}

// Payload for Google Apps Script
export interface ApiPayload {
  action: 'get' | 'addIdea' | 'updateIdea' | 'deleteIdea' | 'addTopic' | 'addChat' | 'getChats' | 'verifyPin';
  data?: any;
  page?: number; // For chat pagination
}